import { SomacylEntregablesDTO } from "sigo-entities"
import { AdapterGeolocation } from "../../shared/Infraestructure/AdapterGeolocation"
import { indexedDB, SomacylOrderOfflineENTITY } from "../../shared/Infraestructure/useIndexedDB"
import { IBodySomacyl } from "./AddInventory"

export const initOfflineSyncOrdenesSomacylDelete = async (
    dataDB: SomacylOrderOfflineENTITY[],
    pendingOrders: SomacylOrderOfflineENTITY[],
    deleteInventory: (id: string, codigo: number, serie: string) => Promise<void>,
) => {

    const invEliminar: { id: string, codigo: number, serie: string }[] = []

    for (const order of pendingOrders) {
        const orderDB = dataDB.find((e) => e._id === order._id)
        if (!orderDB) continue
        for (const inv of orderDB.inventory) {
            const exist = order.inventory.some(e => e.ID_Stock === inv.ID_Stock && e.invsn === inv.invsn)
            if (!exist) {
                invEliminar.push({
                    id: order._id,
                    codigo: inv.ID_Stock,
                    serie: inv.invsn
                })
            }
        }
    }
    for (const item of invEliminar) {
        await deleteInventory(item.id, item.codigo, item.serie)
    }

    return !!invEliminar.length
}

export const initOfflineSyncOrdenesSomacylAdd = async (
    dataDB: SomacylOrderOfflineENTITY[],
    pendingOrders: SomacylOrderOfflineENTITY[],
    addInventory: (body: IBodySomacyl, id: string) => Promise<void>
) => {
    const invAgregar: { id: string, body: IBodySomacyl }[] = []

    for (const order of pendingOrders) {
        const orderDB = dataDB.find((e) => e._id === order._id)
        if (!orderDB) continue
        for (const inv of order.inventory) {
            if (inv.codigo === 'SOMACYL0000') { continue }
            const exist = orderDB.inventory.some(e => e.ID_Stock === inv.ID_Stock && e.invsn === inv.invsn)
            if (!exist) {
                const coodenadas = await AdapterGeolocation.getLocation()
                const body: IBodySomacyl = {
                    ID_Stock: inv.ID_Stock,
                    cantidad: inv.cantidad,
                    lecturaContadorRetirado: order.entregables.lectura_contador_retirado || '',
                    lecturaContadorInstalado: order.entregables.lectura_contador_instalado || '',
                    observaciones: order.entregables.observaciones,
                    latitud: coodenadas.latitud,
                    longitud: coodenadas.longitud,
                    clasificacion_incidencia: order.clasificacion_incidencia
                }
                body.Serie = inv.invsn === '' ? undefined : inv.invsn

                const deInstall = inv.descripcion.includes('CONTADOR')
                if (deInstall) {
                    const _deInstall = order.inventory.find(e => e.codigo === 'SOMACYL0000')
                    if (!_deInstall) {
                        throw new Error('No se encontró el item SOMACYL0000')
                    }
                    body.SerieDeinstall = {
                        Serie: _deInstall.invsn,
                        Codigo: _deInstall.codigo,
                        Descripcion: _deInstall.descripcion,
                    }
                }
                invAgregar.push({
                    id: order._id,
                    body: body
                })
            }
        }
    }

    for (const item of invAgregar) {
        await addInventory(item.body, item.id)
    }

    return !!invAgregar.length
}

// Busca la imagen en caché que corresponde a un Filename. Un Filename vacío
// (valor por defecto de FilesDocDTO) no identifica ningún archivo real, así que
// se descarta explícitamente: `e.id.includes('')` sería true para cualquier
// elemento del array y emparejaría con el primero por error.
const findCachedImage = (data: { id: string, file: File }[], filename: string) => {
    if (!filename) return undefined
    return data.find((e) => e.id.includes(filename))
}

export const initOfflineSyncOrdenesSomacylUploadPhotos = async (
    dataDB: SomacylOrderOfflineENTITY[],
    pendingOrders: SomacylOrderOfflineENTITY[],
    uploadPhotosSomacylOrders: (entregables: SomacylEntregablesDTO, id: string, files: File[]) => Promise<void>
) => {
    const data = await indexedDB.images_somacyl_orders.toArray()
    const fotosAgregar: { entregables: SomacylEntregablesDTO, id: string, files: File[], cacheIds: string[] }[] = []

    for (const order of pendingOrders) {
        const orderDB = dataDB.find((e) => e._id === order._id)
        if (!orderDB) continue
        const fotoAntes = findCachedImage(data, order.entregables.foto_antes.Filename)
        const fotoDespues = findCachedImage(data, order.entregables.foto_despues.Filename)
        const conjuntoMedidaAntes = findCachedImage(data, order.entregables.conjunto_medida_antes.Filename)
        const conjuntoMedidaDespues = findCachedImage(data, order.entregables.conjunto_medida_despues.Filename)

        // Se sincroniza lo que esté cacheado, aunque no estén las 4: una orden
        // en curso (ASIGNADO) puede tener legítimamente solo foto antes guardada
        // offline en un momento dado. Exigir las 4 dejaba la orden entera sin
        // sincronizar y, peor, su entregables pendiente terminaba pisado por la
        // respuesta (desactualizada) del servidor en getByIdSomacylOrders.
        const encontradas = [fotoAntes, fotoDespues, conjuntoMedidaAntes, conjuntoMedidaDespues].filter(Boolean) as { id: string, file: File }[]
        if (!encontradas.length) continue

        fotosAgregar.push({
            entregables: order.entregables,
            files: encontradas.map((e) => e.file),
            id: order._id,
            cacheIds: encontradas.map((e) => e.id)
        })
    }

    for (const item of fotosAgregar) {
        await uploadPhotosSomacylOrders(item.entregables, item.id, item.files)
        // Solo se borra del caché lo que efectivamente se subió.
        await indexedDB.images_somacyl_orders.bulkDelete(item.cacheIds)
    }

    return !!fotosAgregar.length
}